import { Form } from '@domain-group/suit-theme'

import EnabledPermission from '@components/EnabledPermission'

import { getCampaignType } from '@functions/campaign'

import type { useCreateOrEditOrderItemTaskModalPayload } from
  '@modals/CreateOrEditOrderItemTaskModal/hooks/useCreateOrEditOrderItemTaskModal'

interface SelectOrderItemProps {
  hookPayload: useCreateOrEditOrderItemTaskModalPayload,
}

const SelectOrderItem = (props: SelectOrderItemProps) => {
  const { hookPayload } = props

  const {
    filteredOrderItems,
    campaign,
    formPayload,
    isAgencyUser,
    newRecord,
    orderItemTask,
  } = hookPayload

  const {
    entityState: { order_item_id },
    handlers,
  } = formPayload

  if (!newRecord || !isAgencyUser || !!orderItemTask.order_item_id) return null

  return (
    <EnabledPermission
      campaignType={getCampaignType(campaign)}
      permissionKey="campaign.tasks.manage"
    >
      <Form.Field label="* Order Item" boxProps={{ marginBottom: 'large' }}>
        {/*
         // @ts-expect-error TS2322 */}
        <select name="order_item_id" value={order_item_id} {...handlers}>
          <option value="">Please Select...</option>
          {filteredOrderItems.map(orderItem => (
            <option value={orderItem.id}>{orderItem.title}</option>
          ))}
        </select>
      </Form.Field>
    </EnabledPermission>
  )
}

export default SelectOrderItem
